import SeoInfo from "@common/components/SeoInfo";
import { LocaleProps } from "@common/types/LocaleProps";
import ProfileLayout from "@layouts/profile/ProfileLayout";
import PublicLayout from "@layouts/public/components/PublicLayout";
import SavedVehicles from "@modules/profile/components/saved-vehicles/SavedVehicles";
import UnAuthSavedVehiclesSideMenu from "@modules/profile/components/unAuthenticated/UnAuthSavedVehiclesSideMenu";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useState, ReactElement } from "react";

const SavedVehiclesPage = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { t } = useTranslation(["profile"]);

  const showMenuOnClick = () => {
    setShowMenu(true);
  };

  const hideMenuOnClick = () => {
    setShowMenu(false);
  };

  return (
    <>
      <SeoInfo seoInfo={{ title: t("profile:profile_saved_vehicles_title") }} />
      <ProfileLayout
        onHideMenuClick={hideMenuOnClick}
        showSideMenu={showMenu}
        unAuthenticatedMenu={<UnAuthSavedVehiclesSideMenu />}
      >
        <SavedVehicles onShowMenuClick={showMenuOnClick} />
      </ProfileLayout>
    </>
  );
};

SavedVehiclesPage.pageName = "SavedVehiclesProfilePage";
SavedVehiclesPage.getLayout = (page: ReactElement) => (
  <PublicLayout>{page}</PublicLayout>
);

export const getStaticProps = async ({ locale }: LocaleProps) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "profile",
      "vehicle",
      "staticPromoCards",
      "vehiclesPage",
    ])),
  },
});

export default SavedVehiclesPage;
